// Lightweight Facebook / Meta Pixel helper
const initializedPixels = new Set();

export function initFacebookPixel(pixelId) {
  if (typeof window === 'undefined' || !pixelId) return;

  if (!window.fbq) {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  }

  if (initializedPixels.has(pixelId)) return;

  try {
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
    initializedPixels.add(pixelId);
  } catch (e) {
    // Do not throw; pixel is non-critical
    // eslint-disable-next-line no-console
    console.warn('[FB Pixel] init error', e);
  }
}

function buildFacebookProductPayload({ value = 0, currency = 'USD', content_type = 'product', content_ids = [], num_items = 1, content_name } = {}) {
  const payload = {
    value: Number(value) || 0,
    currency,
    content_type,
    content_ids,
    num_items,
  };
  if (content_name) payload.content_name = content_name;
  return payload;
}

export function trackFacebookEvent(eventName, options = {}) {
  if (typeof window === 'undefined' || !eventName || !window.fbq) return;

  try {
    window.fbq('track', eventName, buildFacebookProductPayload(options));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(`[FB Pixel] track ${eventName} error`, e);
  }
}

export function trackFacebookAddToCart(options = {}) {
  trackFacebookEvent('AddToCart', options);
}

export function trackFacebookPurchase(options = {}) {
  trackFacebookEvent('Purchase', options);
}

export default {
  initFacebookPixel,
  trackFacebookAddToCart,
  trackFacebookPurchase,
};
